import { Component } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { CourtSystemParams } from '@ftr/routing-paths'
import { routeParam } from '~app/pages/utils/route-param.signal'

@Component({
  selector: 'ftr-forbidden-page',
  template: '<ftr-forbidden [courtSystemId]="courtSystemId()"></ftr-forbidden>',
  standalone: false,
})
export class ForbiddenPage {
  protected readonly courtSystemId = routeParam<Uuid>(CourtSystemParams.CourtSystemId)
}
